import { DialogActions, DialogContent, Grid, TextField } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';
import printImg from "../../../images/ACKReport/AckPrint.svg";
import header from '../../../images/header/header-logo.svg';
import { IClosedLetterDetails } from '../../../models/Inquiry/LetterDetails/IClosedLetterDetails';
import { ILetterDetails } from '../../../models/Inquiry/LetterDetails/ILetterDetails';
import { useGlobalState } from '../../../store/GlobalStore';
import { Transition } from '../../GlobalStyles/DialogBoxTransition';
import LightTooltip from '../../GlobalStyles/LightTooltip';
import { usePost } from '../../../utils/apiHelper';
import { DialogTitleHeader } from '../../GlobalStyles/DialogStyle';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        appBar: {
            position: 'relative',
            backgroundColor: "#007FFF"
        },
        title: {
            marginLeft: theme.spacing(2),
            flex: 1,
        },
        letterbutton: {
            marginTop: "5px",
            borderRadius: 20,
            fontSize: 12,
            width: 350
        },
        head: {
            display: "flex",
            flexDirection: "column",
            borderSpacing: "1cm",
            width: 375,
            color: "primary",
        },
        menuButton: {
            marginRight: theme.spacing(2),
            width: 220
        },
        report: {
            overflowX: 'hidden'
        },
        dividerStyle: {
            marginTop: "5px",
            height: '2px',
            background: "black"
        },
        TypographyStyle: {
            fontSize: 13,
            marginTop: "30px"
        },
        TypographyStyle1: {
            fontSize: 13,
            marginTop: "3px"
        },
        TypographyStyle2: {
            fontSize: 13,
            marginTop: "40px"
        },
        TypographyStyle3: {
            fontSize: 13,
            marginTop: "10px"
        },
        TypographyStyle4: {
            marginTop: "20px",
            fontSize: 13
        },
        titleheader: {
            fontWeight: 'bold',
            marginTop: '5px',
            color: 'white'
        },
        dialogePaper: {
            minWidth: "800px"
        },
    }),
);


const PaidLetter: React.FC<{ dbtNumber: string, letterDetails: IClosedLetterDetails[], GetDebtorLetterDetails: ILetterDetails[] }> = (props) => {
    const classes = useStyles();
    const { state } = useGlobalState();
    const [open, setOpen] = useState(false);
    const [requestReasonOpen, setRequestReasonOpen] = useState(false);
    const [requestReason, setRequestReason] = useState('');
    const [isSubmitting, setSubmitting] = useState(false);
    const [isSubmitted, setSubmitted] = useState(false);
    const componentRef = useRef<HTMLDivElement>(null);

    const handleOpen = () => {
        const role = state?.userAccessContext?.global_admin ?? state?.userAccessContext?.role;
        if (role === 3 || role === 2) {
            setOpen(true);
        } else {
            setRequestReasonOpen(true);
        }
    };

    const submitRequest = () => {
        const letter = props.GetDebtorLetterDetails?.[0];
        let request = {
            "debtorNumber": props.dbtNumber,
            "clientId": letter?.dbT_CLIENT || '',
            "clientAccountNumber": letter?.dbT_CLNT_ACNT1 || '',
            "letterType": 'PaidLetter',
            "letterName": 'Paid Letter',
            "requestedByUserId": state.userAccessContext?.id || 0,
            "requestedByEmail": state.user?.email || state.userAccessContext?.userName || '',
            "requestedByName": state.user?.name || `${state.userAccessContext?.firstName || ''} ${state.userAccessContext?.lastName || ''}`.trim(),
            "requestReason": requestReason.trim(),
        };
        setSubmitting(true);
        (async () => {
            await usePost('ClosedLetterRequestCreate', request);
            setSubmitted(true);
            setRequestReasonOpen(false);
            setRequestReason('');
        })().finally(() => {
            setRequestReason('');
            setSubmitting(false);
            setRequestReasonOpen(false);
        });
    };

    const handleClose = () => {
        setOpen(false);
        setRequestReason('');
        setRequestReasonOpen(false);
    };

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: (state?.userAccessContext?.global_admin === 0 || state?.userAccessContext?.role === 1) ? "flex-start" : "flex-end",
                    alignItems: "center",
                    gap: "8px",
                    width: "120%"
                }}
            >
                <Button onClick={handleOpen} disabled={!props?.letterDetails[0]?.paid_Letter} size="small"
                    className={classes.letterbutton} variant="contained" color="primary" startIcon={<FileCopyIcon />} >
                    Paid Letter
                </Button>

                {(state?.userAccessContext?.global_admin === 0 || state?.userAccessContext?.role === 1) && (
                    <Button
                        onClick={() => setRequestReasonOpen(true)}
                        size="small"
                        variant="contained"
                        color="primary"
                        disabled={!props?.letterDetails[0]?.paid_Letter || isSubmitting || isSubmitted}
                    >
                        {isSubmitted ? 'Request Sent' : 'Request Letter'}
                    </Button>
                )}
            </div>
            <Dialog open={requestReasonOpen} maxWidth="sm" fullWidth keepMounted onClose={handleClose}
                classes={{ paper: classes.dialogePaper }} PaperProps={{ style: { borderRadius: 15 } }}
                aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
                <DialogTitleHeader id="responsive-dialog-title" onClose={handleClose}>
                    <Typography variant="h6" gutterBottom className={classes.titleheader}>
                        Letter Request Required (Paid Letter)
                    </Typography>
                </DialogTitleHeader>
                <DialogContent>
                    <Typography variant="body2" style={{ marginBottom: 16 }}>
                        Letters are not available for direct download.
                        <br /><br />
                        Kindly submit a request, and the administrative team will review and provide the letter upon approval.
                    </Typography>

                    <TextField
                        label="Request Reason"
                        value={requestReason}
                        onChange={(e) => setRequestReason(e.target.value)}
                        variant="outlined"
                        multiline
                        rows={4}
                        fullWidth
                        inputProps={{ maxLength: 500 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRequestReasonOpen(false)} variant="contained" color="primary">Cancel</Button>
                    <Button onClick={submitRequest} color="primary" variant="contained" disabled={!requestReason.trim() || isSubmitting}>
                        Submit Request
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Paid Letter
                        </Typography>
                        <ReactToPrint
                            trigger={() =>
                                <LightTooltip title="Print Letter">
                                    <IconButton color="primary" id="RB_PrintIcon" aria-label="print" component="label">
                                        <img src={printImg} alt="Icon for Print" width="35px" height="30px" />
                                    </IconButton>
                                </LightTooltip>
                            }
                            content={() => componentRef.current}
                        />
                    </Toolbar>
                </AppBar>
                {props.GetDebtorLetterDetails.map((letter) => {
                    return (
                        <div ref={componentRef} className={classes.report}>
                            <DialogContent dividers>
                                <img alt="ARM Solutions" className={classes.menuButton} src={header} />
                                <Divider className={classes.dividerStyle} />
                                <Typography variant="body1" align="left" className={classes.TypographyStyle3}>
                                    {`${moment(new Date()).format('MMMM DD,YYYY')}`}
                                </Typography>
                                <Typography variant="h6" align="left" className={classes.TypographyStyle4}>
                                    {letter?.dbT_NAME?.toUpperCase()}
                                </Typography>
                                <Typography variant="h6" align="left" style={{ fontSize: 13 }}>
                                    {letter?.deM_ADDR1?.toUpperCase()}
                                </Typography>
                                <Typography variant="h6" align="left" style={{ fontSize: 13 }}>
                                    {letter?.deM_CITY?.toUpperCase()}, {letter?.deM_STATE?.toUpperCase()} , {letter?.deM_ZIP?.toUpperCase()}
                                </Typography>
                                <Typography variant="h6" align="left" className={classes.TypographyStyle}>
                                    Client Name: {letter?.clT_NAME_1?.toUpperCase()}
                                </Typography>
                                <Typography variant="h6" align="left" className={classes.TypographyStyle1}>
                                    Client Account Number: {letter?.dbT_CLNT_ACNT1?.toUpperCase()}
                                </Typography>
                                <Typography variant="h6" align="left" className={classes.TypographyStyle1}>
                                    Customer Account Number: {letter?.dbT_NO?.toUpperCase()}
                                </Typography>
                                <Typography variant="h6" align="left" className={classes.TypographyStyle2}>
                                    Dear {letter?.dbT_NAME?.toUpperCase()},
                                </Typography>
                                <Typography variant="h6" gutterBottom className={classes.TypographyStyle}>
                                    This is to advise you that we have been informed that your account referred on {moment(letter?.dbT_REFERRAL_DATE?.split('T')[0]).format(state.GlobalUtils?.settingValue)}, referenced above, is now a resolved account.
                                    our records indicate that {letter?.dbT_NAME?.toUpperCase()}'s account {letter.dbT_NO} has been satisfied.
                                    Your account with us has been updated to reflect this. All collection activity has been stopped. Furthermore, if your credit was affected, this mark will be updated.
                                </Typography>
                                <Typography variant="h6" gutterBottom className={classes.TypographyStyle}>
                                    Should you have any questions regarding this, please feel free to contact us directly at 888-772-6468.
                                </Typography>
                                <Typography variant="h6" align="left" className={classes.TypographyStyle}>
                                    Sincerely,<br />
                                    The Customer Service Team<br />
                                    A.R.M. Solutions
                                </Typography>
                                <Divider className={classes.dividerStyle} />
                                <Grid item xs={12}>
                                    <Typography variant="body1" align="left" gutterBottom style={{ fontSize: 13, marginTop: '7px' }}>
                                        <b>California License No.: 10207-99   PO Box 2929, Camarillo, CA 93011 &nbsp;&nbsp;&nbsp;<b style={{ color: 'red' }}>T</b>  888.772.6468 &nbsp;&nbsp;&nbsp;<b style={{ color: 'red' }}>F</b> 805.830.1104</b>
                                        <b style={{ color: 'red', float: 'right' }}>ARMSolutions.com</b>
                                    </Typography>
                                </Grid>
                            </DialogContent>
                        </div>
                    )
                })}
            </Dialog >
        </div >
    );
}

export default PaidLetter
